const ORG_PERSON_NODE_TYPES = new Set([
  'org_person',
  'org_person_photo',
  'org_person_photo_left',
  'org_person_photo_right',
  'org_person_photo_inner_left',
  'org_person_text',
]);

type OrgChartScenarioUpdatableNode = Record<string, unknown> & {
  type?: unknown;
  attrs?: unknown;
  props?: unknown;
  name?: unknown;
};

function writeField(container: unknown, field: string, newValue: unknown): Record<string, unknown> {
  const next = typeof container === 'object' && container !== null
    ? { ...(container as Record<string, unknown>) }
    : {};
  next[field] = newValue;
  return next;
}

function isOrgPersonNodeType(type: unknown): boolean {
  return typeof type === 'string' && ORG_PERSON_NODE_TYPES.has(type);
}

export function applyOrgChartScenarioFieldUpdate<T extends OrgChartScenarioUpdatableNode>(
  node: T,
  field: string,
  newValue: unknown,
): T {
  const updated = {
    ...node,
    [field]: newValue,
    attrs: writeField(node.attrs, field, newValue),
    props: writeField(node.props, field, newValue),
  } as T;

  if (field === 'name' && typeof newValue === 'string') {
    updated.name = newValue;
  }

  // Person cards render `role` before `title`, so promotion-style title updates
  // must keep the subtitle field in sync for org-person node variants. The
  // person panel records a title edit as `role` and shows `title`, which a
  // live chart sets for a seatless person ("Unassigned"), so the reverse
  // holds too or the panel shows the stale title over the draft.
  if ((field === 'title' || field === 'role') && isOrgPersonNodeType(node.type)) {
    const other = field === 'title' ? 'role' : 'title';
    (updated as Record<string, unknown>)[other] = newValue;
    (updated.attrs as Record<string, unknown>)[other] = newValue;
    (updated.props as Record<string, unknown>)[other] = newValue;
  }

  return updated;
}
